import React from 'react'

export type MBSelectProps = JSX.IntrinsicElements['select'] & {
  hasError: boolean
}
export const MBSelect: React.VFC<MBSelectProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {hasError, ...rest} = props
  return (
    <select{...rest}>{props.children}</select>
  )
}
